import { createFileRoute, Outlet } from "@tanstack/react-router";
import { settingsRoute } from "@/features/account-access";

export const Route = createFileRoute("/settings")({
    ssr: settingsRoute.ssr,
    component: Outlet,
});
